import { render, staticRenderFns } from "./auditTrailTabComponent.vue?vue&type=template&id=58ebdb1a"
import script from "./auditTrailTabComponent.vue?vue&type=script&lang=js"
export * from "./auditTrailTabComponent.vue?vue&type=script&lang=js"
import style0 from "./auditTrailTabComponent.vue?vue&type=style&index=0&id=58ebdb1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports